export const baseApiUrl = 'https://api.mgcash.app.br' // produção
export const baseAuthApiUrl = 'https://api-auth.mgcash.app.br' // produção
export const baseFrotendUrl = 'https://mgcash.app.br' // produção
export const baseFrotendAuth = "https://auth.mgcash.app.br" // produção
